// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"033ba87626a4550aa0ab","454":"e33b8ddbe0c603a6ff86"}[chunkId] + ".js";
};